$(document).ready(function () {

    if ($('#bloc-objectif-prevoyance-devis').length) {

        let displayElement = document.getElementById('bloc-objectif-prevoyance-devis');

        let uuid = displayElement.dataset.loadingId;
        let url = '/objectif-prevoyance/get-devis/' + uuid;
        const intervalID = setInterval(getDevis, 1000);

        function getDevis() {

            $.ajax({
                url,
                type: 'get',
                dataType: 'html',
                beforeSend: function () {
                },
                error: function (render, textStatus, xhr) {
                    displayElement.innerHTML = render;
                },
                success: function (render, textStatus, xhr) {
                    if (xhr.status === 200) {
                        displayElement.innerHTML = render;
                        clearInterval(intervalID);

                        document.dispatchEvent(new CustomEvent('ForceRender', {
                            detail: {
                                selector: '#etre-appele-devis'
                            }
                        }));
                    }
                }
            });
        }
    }

    if ($('#bloc-objectif-prevoyance-tarifs').length) {

        // Bouton "continuer" désactivé
        $('#bt-next').attr('disabled', 'disabled');

        let displayElement = $('#bloc-objectif-prevoyance-tarifs');

        let uuid = $('input[name="uuid"]').val();
        let url = '/objectif-prevoyance/get-tarif/' + uuid;

        const intervalID = setInterval(getTarif, 1000);

        function getTarif() {

            $.ajax({
                url,
                type: 'get',
                dataType: 'html',
                beforeSend: function () {
                },
                error: function (render, textStatus, xhr) {
                    displayElement.html(render)
                },
                success: function (render, textStatus, xhr) {
                    if (xhr.status === 200) {

                        displayElement.html(render)

                        // Bouton "continuer" réactivé
                        $('#bt-next').removeAttr('disabled');

                        clearInterval(intervalID)

                        $('input[name="formule"]').change(function () {
                            $("input[name='formule_visible']").val($(this).val());
                        });

                        $('input[name="formule_visible"]').change(function () {
                            $("input[name='formule']").val($(this).val());
                        });

                        $("input[name='formule_visible'][value='" + $('input[name="formule"]').val() + "']").attr("checked", "checked");
                    }
                }
            });
        }
    }
});
